import axios, { type AxiosResponse } from "axios";
import deploymentVendorsMockResult from "./mockup/deployment-vendors-mock-result.json";
import {
  DeploymentDataType,
  ProductItemType,
  DeploymentSubscriptionAssignDataType,
  DeploymentFuelBrandItemType,
  DeploymentCashRegisterItemType,
  DeploymentVendorItemType,
} from "@/schemas/index";
import {
  DeploymentDataSchema,
  DeploymentFuelBrandItemSchema,
  DeploymentCashRegisterItemSchema,
  DeploymentVendorItemSchema,
} from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceDeploymentApi {
  fetchDeploymentSummary: (
    productId: ProductItemType["Id"],
  ) => Promise<DeploymentDataType>;
  fetchVendors: () => Promise<DeploymentVendorItemType[]>;
  fetchSubscriptionAssign: (data: any) => Promise<any>;
  fetchDeploymentCashRegisters: () => Promise<DeploymentCashRegisterItemType[]>;
  fetchDeploymentFuelBrands: () => Promise<DeploymentFuelBrandItemType[]>;
}

export const serviceDeploymentApi: ServiceDeploymentApi = {
  fetchSubscriptionAssign: (data: DeploymentSubscriptionAssignDataType) => {
    return axios
      .post(`${env.services.portal}/deployment`, data)
      .then((response: AxiosResponse<unknown>) => response?.data);
  },

  fetchVendors: () => {
    return Promise.resolve(
      deploymentVendorsMockResult.map((item) =>
        DeploymentVendorItemSchema.parse(item),
      ),
    );
  },

  fetchDeploymentSummary: (productId) => {
    return axios
      .get(`${env.services.portal}/deployment/summary/${productId}`)
      .then((response: AxiosResponse<unknown>) =>
        DeploymentDataSchema.parse({
          ...(response?.data as Record<string, unknown>),
          Vendors: deploymentVendorsMockResult,
        }),
      );
  },

  fetchDeploymentCashRegisters: () => {
    return axios
      .get(`${env.services.portal}/deployment/cashregisters`)
      .then((response: AxiosResponse<unknown[]>) =>
        response?.data.map((item) =>
          DeploymentCashRegisterItemSchema.parse(item),
        ),
      );
  },

  fetchDeploymentFuelBrands: () => {
    return axios
      .get(`${env.services.portal}/deployment/fuelbrands`)
      .then((response: AxiosResponse<unknown[]>) =>
        response?.data.map((item) => DeploymentFuelBrandItemSchema.parse(item)),
      );
  },
};
